import { render, staticRenderFns } from "./BoxDrawer.vue?vue&type=template&id=d6427f0e&scoped=true&"
import script from "./BoxDrawer.vue?vue&type=script&lang=js&"
export * from "./BoxDrawer.vue?vue&type=script&lang=js&"
import style0 from "./BoxDrawer.vue?vue&type=style&index=0&id=d6427f0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6427f0e",
  null
  
)

export default component.exports